import { z } from "zod";
import { emailSchema } from "../utils/validation.js";
export const contactRequestSchema = z.object({
    name: z.string().trim().min(1, "Le nom est requis").max(100, "Le nom est trop long"),
    email: emailSchema,
    message: z.string().trim().min(10, "Le message est trop court").max(5000, "Le message est trop long"),
    captchaToken: z.string().optional(),
});
